import React, { useEffect } from 'react';

import { useFormik } from 'formik';
import { formLoginValidator } from './FormLoginValidator';

import FormControl from '@material-ui/core/FormControl';
import Divider from '@material-ui/core/Divider';

import TextField from '@material-ui/core/TextField';

import logoCompany from '../../assets/img/logo.png';
import facebookIcon from '../../assets/icons/facebookIcon.svg';
import instagramIcon from '../../assets/icons/instagramIcon.svg';
import linkedinIcon from '../../assets/icons/linkedinIcon.svg';

import './styles.scss'

const FormLogin = ({
    formPage,
    action,
    modalSenha,
    modalAcesso
}) => {

    const formik = useFormik({
        initialValues: formPage,
        validationSchema: formLoginValidator,
        onSubmit: (values) => {
            logar(values);
        }
    })

    const logar = (values) => {
        action(values)
    }

    useEffect(() => {
        async function init() {
        }
        init()
    }, [])

    return (
        <form onSubmit={formik.handleSubmit}>
            <div class="container fontMonserrat"  >
                <div class="row mTop100" >
                    <div class="col-sm-12 containerImageResponsive" >
                        <br/>
                        <img src={logoCompany} alt="greener" class="w100p" />
                    </div>
                </div>
                <div className="row mTop50">
                    <div class="col-sm-12" >
                        <FormControl>
                                <TextField
                                    label="E-mail"
                                    placeholder="Informe seu e-mail cadastrado"
                                    type="text"
                                    size="small"
                                    className="TextField"
                                    id="email"
                                    variant="outlined"
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    error={formik.touched.email && Boolean(formik.errors.email)}
                                    helperText={formik.touched.email && formik.errors.email}
                                />
                        </FormControl>
                    </div>    
                </div>
                <div className='row'>
                    <div className='col-sm-12' >
                        <FormControl >
                            <TextField
                                label="Senha"
                                placeholder="Informe a senha"
                                type="password"
                                size="small"
                                id="senha"
                                variant="outlined"
                                value={formik.values.senha}
                                onChange={formik.handleChange}
                                error={formik.touched.senha && Boolean(formik.errors.senha)}
                                helperText={formik.touched.senha && formik.errors.senha}
                            />
                        </FormControl>
                    </div>
                </div>
                <div className=" row">
                    <div className='esqueciSenhaContainer col-sm-12' >
                        <div className='esqueciSenhaContainer  w120 alignRight fontMonserrat' >
                            <span   style={{ cursor: 'pointer' }} className='' onClick={modalSenha}>
                                Esqueci a senha
                            </span>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className="col-sm-12  " >
                        <center>
                            <button className="btn btn-outline-light btn-block btn-lg  " type='submit'>
                                Entrar
                            </button>
                        </center>
                    </div>   
                </div>
                <div className='primeiro-acesso row '>
                    <div className='col-sm-12' >
                        <center>
                            <a onClick={modalAcesso}>PRIMEIRO ACESSO</a>
                        </center>
                    </div>
                </div>
                <div className='primeiro-acesso row'>
                    <div className='col-sm-12 ' >
                        <div className="divider w100p">
                            <Divider light variant="fullWidth" class="w100p" />
                        </div>        
                    </div>
                </div>
                <div className="row" >
                    <div class="col-sm-12" >
                        <center>
                            <div className="copyright">
                                <p>&#169; GREENERS 2021. Todos os direitos reservados.</p>
                            </div>
                        </center>
                        
                        <div className="midia-sociais">
                            
                            
                            
                        </div>
                    </div>
                </div>
                <div className="row  h50" >
                    <div class="col-sm-4 textRight maxWidth33" >
                        <a href="https://www.linkedin.com/company/greeners-tech/" target="_blank"><img src={linkedinIcon} /></a>
                    </div>
                    <div class="col-sm-4 textCenter maxWidth33" >
                        <a href="https://www.facebook.com/greeners.tech" target="_blank"><img src={facebookIcon} /></a>
                    </div>
                    <div class="col-sm-4 maxWidth33" >
                        <a href="https://www.instagram.com/greeners_tech/" target="_blank"><img src={instagramIcon} /></a>
                    </div>
                </div>

            </div>
        </form>
    )
}

export default FormLogin;

/*

<form onSubmit={formik.handleSubmit}>
            <div className="limitContainer container">
                <div className="containerImage row">
                    <img src={logoCompany} alt="greener" />
                </div>

                <div className='container'>
                    <div className="row">
                        <FormControl>
                            <TextField
                                label="E-mail"
                                placeholder="Informe seu e-mail cadastrado"
                                type="text"
                                size="small"
                                className="TextField"
                                id="email"
                                variant="outlined"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                error={formik.touched.email && Boolean(formik.errors.email)}
                                helperText={formik.touched.email && formik.errors.email}
                            />
                        </FormControl>
                    </div>

                    <div className='row'>
                        <FormControl >
                            <TextField
                                label="Senha"
                                placeholder="Informe a senha"
                                type="password"
                                size="small"
                                id="senha"
                                variant="outlined"
                                value={formik.values.senha}
                                onChange={formik.handleChange}
                                error={formik.touched.senha && Boolean(formik.errors.senha)}
                                helperText={formik.touched.senha && formik.errors.senha}
                            />
                        </FormControl>
                    </div>

                    <div className="esqueciSenhaContainer row">
                        <span   style={{ cursor: 'pointer' }} onClick={modalSenha}>
                            Esqueci a senha
                        </span>
                    </div>

                    <div className='row'>
                        <button className="btn btn-outline-light btn-block btn-lg" type='submit'>
                            Entrar
                        </button>
                    </div>

                    <div className='primeiro-acesso row'>
                        <a onClick={modalAcesso}>PRIMEIRO ACESSO</a>
                    </div>

                    <div className="divider">
                        <Divider light variant="fullWidth" />
                    </div>

                    <footer>
                        <div className="copyright">
                            <p>&#169; GREENERS 2021. Todos os direitos reservados.</p>
                        </div>

                        <div className="midia-sociais">
                            <a href="https://www.linkedin.com/company/greeners-tech/" target="_blank"><img src={linkedinIcon} /></a>
                            <a href="https://www.facebook.com/greeners.tech" target="_blank"><img src={facebookIcon} /></a>
                            <a href="https://www.instagram.com/greeners_tech/" target="_blank"><img src={instagramIcon} /></a>
                        </div>
                    </footer>
                </div>

            </div>
        </form>

*/